import { render, staticRenderFns } from "./rightsDialog.vue.js?vue&type=template&id=72a4ce91&scoped=true!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./rightsDialog.vue?vue&type=template&id=72a4ce91&scoped=true"
import script from "./rightsDialog.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./rightsDialog.vue?vue&type=script&lang=js"
export * from "./rightsDialog.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./rightsDialog.vue?vue&type=script&lang=js"
import style0 from "./rightsDialog.vue.scss?vue&type=style&index=0&id=72a4ce91&lang=scss&scoped=true!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./rightsDialog.vue?vue&type=style&index=0&id=72a4ce91&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a4ce91",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72a4ce91')) {
      api.createRecord('72a4ce91', component.options)
    } else {
      api.reload('72a4ce91', component.options)
    }
    module.hot.accept("./rightsDialog.vue.js?vue&type=template&id=72a4ce91&scoped=true!=!../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./rightsDialog.vue?vue&type=template&id=72a4ce91&scoped=true", function () {
      api.rerender('72a4ce91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AIHelper/components/aiCenter/rightsDialog.vue"
export default component.exports